export { default as StoreCard } from './store-card';
